import { testimonials } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        kicker="读者口碑"
        title="他们说，瓜要趁早吃"
        desc="一群习惯在清晨看早报的读者，把吃瓜今日当成了每天的第一站。"
        align="center"
      />

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="relative flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-accent-200"
          >
            <i className="ri-double-quotes-l absolute right-5 top-5 text-2xl text-accent-200" />
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-lg text-accent-700">
              <i className="ri-star-fill h-4 w-4" />
            </span>
            <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
                {t.avatarText}
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}